import { z } from 'zod'
import { AddressSchema, BirthdateSchema, InvoiceSchema } from '@ca/common'
import { contactModalSchema } from '@user/customer/contactSchemas'

export { contactModalSchema }

export const personalInfoStepSchema = z.object({
  first_name: z.string().min(2, 'minLength.2'),
  last_name: z.string().min(2, 'minLength.2'),
})

const contactFieldsSchema = z.object({
  mobile: z.string().optional(),
  email: z.string().optional(),
})

export const parentDataSchema = z.object({
  first_name: z.string().optional(),
  last_name: z.string().optional(),
  email: z.string().nullable().optional(),
  mobile: z.string().nullable().optional(),
  street: z.string().nullable().optional(),
  street2: z.string().nullable().optional(),
  city: z.string().nullable().optional(),
  zip: z.string().nullable().optional(),
  country_code: z.string().optional(),
  birth_date: z.string().nullable().optional(),
})

export type ParentData = z.infer<typeof parentDataSchema>

export const parentAuthStatusSchema = z.enum([
  'pending',
  'required',
  'verified',
  'failed',
  'skipped',
])

export type ParentAuthStatus = z.infer<typeof parentAuthStatusSchema>

const createCustomerFormSchema = z.object({
  ...personalInfoStepSchema.shape,
  ...contactFieldsSchema.shape,
  birthday: BirthdateSchema,
  phone: z.string().optional(),
  address: AddressSchema,
  invoice: InvoiceSchema.optional(),
  policies: z.record(z.string(), z.boolean()).optional(),
  parentData: parentDataSchema.optional(),
  parentAuthStatus: parentAuthStatusSchema.optional(),
})

export type CreateCustomerData = z.infer<typeof createCustomerFormSchema>
